function setStatus(form, message, state) {
    const status = form.querySelector('[data-newsletter-sign-up-status]');
    if (!status) return;

    const isError = state === 'error';
    const title = status.querySelector('[data-newsletter-sign-up-status-title]');
    const messageElement = status.querySelector('[data-newsletter-sign-up-status-message]');

    if (title) {
        title.textContent = isError
            ? form.dataset.newsletterSignUpErrorTitle
            : form.dataset.newsletterSignUpSuccessTitle;
    }
    if (messageElement) messageElement.textContent = message;

    status.dataset.state = state;
    status.setAttribute('role', isError ? 'alert' : 'status');
    status.classList.remove('hidden');
    status.classList.toggle('border-secondary', isError);
    status.classList.toggle('border-primary', !isError);
    status.querySelector('[data-newsletter-sign-up-error-icon]')?.classList.toggle('hidden', !isError);
    status.querySelector('[data-newsletter-sign-up-success-icon]')?.classList.toggle('hidden', isError);
}

async function submitForm(form) {
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('disabled', 'disabled');
    button?.setAttribute('aria-busy', 'true');
    button?.classList.add('opacity-60');

    try {
        const response = await fetch(form.action, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
        });
        const payload = await response.json().catch(() => ({}));

        if (!response.ok || payload.success !== true) {
            throw new Error(payload.message || form.dataset.newsletterSignUpGenericErrorMessage);
        }

        form.reset();
        setStatus(form, payload.message, 'success');
    } catch (error) {
        const message = error instanceof Error ? error.message : form.dataset.newsletterSignUpGenericErrorMessage;
        setStatus(form, message, 'error');
    } finally {
        button?.removeAttribute('disabled');
        button?.removeAttribute('aria-busy');
        button?.classList.remove('opacity-60');
    }
}

function attachNewsletterSignUpForms(root = document) {
    const forms = [...root.querySelectorAll('[data-newsletter-sign-up-form]')];
    const cleanupCallbacks = [];

    forms.forEach((form) => {
        const onSubmit = (event) => {
            event.preventDefault();
            void submitForm(form);
        };
        form.addEventListener('submit', onSubmit);
        cleanupCallbacks.push(() => form.removeEventListener('submit', onSubmit));
    });

    return () => cleanupCallbacks.forEach((cleanup) => cleanup());
}

export { attachNewsletterSignUpForms, setStatus, submitForm };
